<template>
    <div>
  
      <Dialog :visible.sync="exibirModal" header="Solicitação" :modal="true" :style="{width: '40vw'}" @hide="fechar">    
        <div v-if="dados">    
          <label class="p-text-bold">{{ dados.solicitacao.funcionario.nomecc }}</label>
          <hr>
          <div class="p-fluid p-formgrid p-grid"> 
              <div class="p-field p-col-6">
                <label>Data da Solicitação</label>
                <InputText class="input-readonly" v-model="dados.solicitacao.data" readonly/>
              </div>
              <div class="p-field p-col-6">
                  <label>Data do Ponto</label>
                  <InputText class="input-readonly" v-model="dados.solicitacao.dataPonto" readonly/>	
              </div>  
              <div class="p-field p-col-12 p-md-12">
                <label>{{ label }}</label>
                <InputText class="input-readonly" v-model="itemPendente.infoCampo1" readonly/>
              </div>                          
              <div class="p-field p-col-12 p-md-12">
                <label class="p-text-bold">Ação</label>
                <Dropdown v-model="acaoSelecionada" :options="acoes" optionLabel="nome" 
                  optionValue="id" placeholder="Selecione" appendTo="body" 
                  :disabled="!exibirBotoes" :class="!exibirBotoes ? 'input-readonly' : ''"/>
              </div> 
              <div class="p-field p-col-12 p-md-12" v-if="acaoSelecionada == naoAprovado">
                <label class="p-text-bold">Observação</label>
                <Textarea v-model.trim="observacaoNaoAprovado" rows="3" cols="30" 
                  :class="!exibirBotoes ? 'input-readonly' : ''" :disabled="!exibirBotoes"/>
              </div>                                 
          </div>        
        </div>
        <template #footer>
            <div class="p-d-flex p-jc-end">
                <div v-if="exibirBotoes">
                    <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirModal = false"/>
                    <Button label="Salvar" icon="pi pi-check" @click="salvar"/>                      
                </div>                              
            </div>            
        </template>        
      </Dialog>

    </div>
  </template>
  
  <script>
  import FolgaService from '@/service/FolgaService.js';
  import ControlePontoService from '@/service/ControlePontoService.js';
  import { exibirMensagemSis, exibirMensagem, acoesSolicitacoesPendentes, clonar } from '@/global';
  import { mapGetters } from 'vuex';
  
  export default {  
      controlePontoService: null,
      folgaService: null,
      props: {
          callback: Function,
      },
      data() {
          return {  
            naoAprovado: 'Não Aprovado',   
            exibirModal: false,             
            itemPendente: {},          
            observacaoNaoAprovado: '',
            dados: null,
            acaoSelecionada: '',         
            acoes: acoesSolicitacoesPendentes,   
            exibirBotoes: false,
            label: 'Folga'                 
          }
      },
      methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        /**
         * 
         * @param {*} dados 
         */
        processar(dados) {           
          this.folgaService = new FolgaService();
          this.controlePontoService = new ControlePontoService();
          this.dados = dados; 
          this.buscarItemSolicitacao();         
        },
         /**
         * 
         * @param {*} solicitacao 
         */
         buscarItemSolicitacao() {           
            let requisicao = {
              idSolicitacao: this.dados.solicitacao.id,
              idFuncionario: this.dados.solicitacao.funcionario.id,
              dataPonto: this.formartarStrData(this.dados.solicitacao.dataPonto, 'US'),
              usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.folgaService.buscarItemSolicitacao(requisicao)
            .then(resp => {
              this.itemPendente = resp.data;
              this.itemPendente['infoCampo1'] = this.formartarStrData(this.itemPendente.infoCampo1, 'BR');
              const solicitacao = this.dados.solicitacao;
              if (solicitacao.status === 'Pendente' && this.dados.permissaoEditar) {
                this.exibirBotoes = true;
              } else {
                this.acaoSelecionada = solicitacao.status;
              }
              if(!solicitacao.observacao) {
                this.dados.solicitacao.observacao = '';
              }
              this.observacaoNaoAprovado = solicitacao.observacao;  
              if(this.itemPendente.acao === 'ATUALIZAR') {
                this.label = 'Atualizar Folga'
              } else if(this.itemPendente.acao === 'EXCLUIR') {
                this.label = 'Excluir Folga'
              } else {
                this.label = 'Folga';
              }
              this.exibirModal = true;
            })
            .catch(erro => {exibirMensagem(this, erro)});           
        },
        /**
         * 
         */
        salvar() { 
          if(this.acaoSelecionada == '') {
            exibirMensagemSis(this, 'Selecione uma ação', true);
            return;
          }
          if(this.acaoSelecionada === this.naoAprovado 
            && this.observacaoNaoAprovado === '') {
            exibirMensagemSis(this, 'Informe um texto breve na observação', true);
            return;
          }         
          let solicitacao = clonar(this.dados.solicitacao);
          delete solicitacao.funcionario;
          solicitacao.status = this.acaoSelecionada;
          solicitacao.observacao = this.observacaoNaoAprovado;
          solicitacao['usuarioAprovacao'] = this.dados.requisicao.usuarioRequisicao.usuario.nome;             
          if(solicitacao.origem === 'FOLGA') {           
            if(this.itemPendente.acao == 'NOVO') {              
              this.resolverPendenciaNovo(solicitacao);
            } else if(this.itemPendente.acao == 'EXCLUIR') {
              this.resolverPendenciaExcluir(solicitacao);
            }
          } else {// CTRL_FOLGA
            if(this.itemPendente.acao == 'NOVO') {              
              this.resolverPendenciaCTRLNovo(solicitacao);
            } else if(this.itemPendente.acao == 'EXCLUIR') {
              this.resolverPendenciaCTRLExcluir(solicitacao);
            }
          }   
        },
        /**
         * 
         */
        resolverPendenciaNovo(solicitacaoAtualizar) {         
          const novaRequisicao = {
            cnpj: this.dados.requisicao.cnpj,
            solicitacao: solicitacaoAtualizar,
            datas: [this.formartarStrData(this.itemPendente.infoCampo1, 'US')],
            funcionarios: [this.dados.solicitacao.funcionario],
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.folgaService.resolverPendenciaNovo(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         */
         resolverPendenciaExcluir(solicitacaoAtualizar) {         
          const novaRequisicao = {
            cnpj: this.dados.requisicao.cnpj,
            solicitacao: solicitacaoAtualizar,
            folga: {
              id: this.itemPendente.idReferencia1,
              data: this.formartarStrData(this.itemPendente.infoCampo1, 'US'),
              funcionario: this.dados.solicitacao.funcionario,
            },
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.folgaService.resolverPendenciaExcluir(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         */
         resolverPendenciaCTRLNovo(solicitacaoAtualizar) {   
          const data = this.formartarStrData(this.itemPendente.infoCampo1, 'US');      
          const novaRequisicao = {
            mes: this.dados.requisicao.mes,
            ano: this.dados.requisicao.ano,
            solicitacao: solicitacaoAtualizar,
            dataInicio: data,
            dataFinal: data,
            idFuncionario: this.dados.solicitacao.funcionario.id,
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.controlePontoService.resolverFolgaPontoDiaNovoPendente(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         */
         resolverPendenciaCTRLExcluir(solicitacaoAtualizar) { 
          const data = this.formartarStrData(this.itemPendente.infoCampo1, 'US');         
          const novaRequisicao = {
            mes: this.dados.requisicao.mes,
            ano: this.dados.requisicao.ano,
            solicitacao: solicitacaoAtualizar,
            dataInicio: data,
            dataFinal: data,
            idFuncionario: this.dados.solicitacao.funcionario.id,
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.controlePontoService.resolverFolgaPontoDiaExcluirPendente(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         * @param {*} strData 
         * @param {*} formato 
         */
         formartarStrData(strData, formato) {   
            if(formato == 'BR') {
                let partes = strData.split('-');
                return partes[2] + '/' + partes[1] + '/' + partes[0];
            }
            let partes = strData.split('/');
            return partes[2] + '-' + partes[1] + '-' + partes[0]; 
        },
        /**
         * 
         */
        fechar() {
          this.exibirModal = false; 
          this.itemPendente = {};          
          this.observacaoNaoAprovado = '';
          this.dados = null;
          this.acaoSelecionada = ''; 
          this.exibirBotoes = false;  
          this.folgaService = null;
          this.controlePontoService = null;
        }       
      }
  }
  </script>
  
  <style scoped>
    .input-readonly {
      background-color: #F2F2F2;
    }
  </style>